import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASEURL;

export default {
  async list() {
    const response = await axios.get(`${API_BASE}/api/exchange`, {
      headers: { Authorization: localStorage.getItem('token') }
    });
    return response.data;
  },

async create(exchangeData) {
  const response = await axios.post(`${API_BASE}/api/exchange`, exchangeData, {
    headers: { Authorization: localStorage.getItem('token') }
  });
  return response.data;
},

  async lock(id, payload) {
    const response = await axios.post( // <-- await was missing
      `${API_BASE}/api/exchanges/${id}/lock`,
      payload,
      { headers: { Authorization: localStorage.getItem('token') } } // optional but consistent
    );
    return response.data; // handle envelope or raw
  },


  async update(id, updates) {
    const response = await axios.put(`${API_BASE}/api/exchange/${id}`, updates, {
      headers: { Authorization: localStorage.getItem('token') }
    });
    return response.data;
  },

  async delete(id) {
    await axios.delete(`${API_BASE}/api/exchange/${id}`, {
      headers: { Authorization: localStorage.getItem('token') }
    });
  },
    // ✅ NEW: connect real exchange (API key + secret)
async addExchange({ email, exchange, apiKey, secretKey }) {
  const body = {
    email,
    exchange,
    API: apiKey,
    secret: secretKey,
  };

  return (await axios.post(`${API_BASE}/api/add_exchange`, body, {
    headers: { Authorization: localStorage.getItem("token") }
  })).data;
},
  async updateKeys(exchangeId, { API_key, SECRET_key, apiKey, secretKey }) {
    const response = await axios.post(
      `${API_BASE}/api/exchange/${exchangeId}/keys`,
      {
        API_key: API_key ?? apiKey,
        SECRET_key: SECRET_key ?? secretKey,
      },
      {
        headers: {
          Authorization: localStorage.getItem('token'),
        },
      }
    );
    return response.data;
  },


};
